/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const addDevice = /* GraphQL */ `
  mutation AddDevice($tenantKey: String, $input: AddDeviceInput!) {
    addDevice(tenantKey: $tenantKey, input: $input) {
      device {
        id
        tenantKey
        propertyId
        buildingId
        unitId
        propertyCode
        buildingCode
        unitCode
        room
        assetType
        isActive
        hierKey
        label
        notes
        lastTelemetryAt
        lastTelemetryAtEpoch
        lastBattV
        lowBatteryActive
        activeLeak
        leakStartedAt
        leakClearedAt
        tiltActive
        tiltConsecutiveCount
        tiltStartedAt
        tiltClearedAt
        healthStatus
        healthHierKey
        healthAssetHierKey
        claimedAt
        firstOnlineAt
        lastSsid
        lastRssi
        connectionCount
        lastBootId
        lastUptime
        lastBootAt
        rebootCount
        firmware
        modelRev
        createdAt
        updatedAt
        __typename
      }
      alreadyOnline
      lastTelemetryAt
      __typename
    }
  }
`;
export const addProperty = /* GraphQL */ `
  mutation AddProperty($tenantKey: String, $input: AddPropertyInput!) {
    addProperty(tenantKey: $tenantKey, input: $input) {
      id
      tenantKey
      code
      name
      address
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const addBuilding = /* GraphQL */ `
  mutation AddBuilding($tenantKey: String, $input: AddBuildingInput!) {
    addBuilding(tenantKey: $tenantKey, input: $input) {
      id
      tenantKey
      propertyId
      code
      name
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const addUnit = /* GraphQL */ `
  mutation AddUnit($tenantKey: String, $input: AddUnitInput!) {
    addUnit(tenantKey: $tenantKey, input: $input) {
      id
      tenantKey
      propertyId
      buildingId
      code
      name
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const editDevice = /* GraphQL */ `
  mutation EditDevice($tenantKey: String, $input: EditDeviceInput!) {
    editDevice(tenantKey: $tenantKey, input: $input) {
      id
      tenantKey
      propertyId
      buildingId
      unitId
      propertyCode
      buildingCode
      unitCode
      room
      assetType
      isActive
      hierKey
      label
      notes
      lastTelemetryAt
      lastTelemetryAtEpoch
      lastBattV
      lowBatteryActive
      activeLeak
      leakStartedAt
      leakClearedAt
      tiltActive
      tiltConsecutiveCount
      tiltStartedAt
      tiltClearedAt
      healthStatus
      healthHierKey
      healthAssetHierKey
      claimedAt
      firstOnlineAt
      lastSsid
      lastRssi
      connectionCount
      lastBootId
      lastUptime
      lastBootAt
      rebootCount
      firmware
      modelRev
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const toggleDeviceActive = /* GraphQL */ `
  mutation ToggleDeviceActive(
    $tenantKey: String
    $input: ToggleDeviceActiveInput!
  ) {
    toggleDeviceActive(tenantKey: $tenantKey, input: $input) {
      id
      tenantKey
      propertyId
      buildingId
      unitId
      propertyCode
      buildingCode
      unitCode
      room
      assetType
      isActive
      hierKey
      label
      notes
      lastTelemetryAt
      lastTelemetryAtEpoch
      lastBattV
      lowBatteryActive
      activeLeak
      leakStartedAt
      leakClearedAt
      tiltActive
      tiltConsecutiveCount
      tiltStartedAt
      tiltClearedAt
      healthStatus
      healthHierKey
      healthAssetHierKey
      claimedAt
      firstOnlineAt
      lastSsid
      lastRssi
      connectionCount
      lastBootId
      lastUptime
      lastBootAt
      rebootCount
      firmware
      modelRev
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const addInvite = /* GraphQL */ `
  mutation AddInvite($tenantKey: String, $input: AddInviteInput!) {
    addInvite(tenantKey: $tenantKey, input: $input) {
      id
      tenantKey
      code
      status
      emailLower
      expiresAt
      createdAt
      createdBySub
      acceptedAt
      acceptedBySub
      updatedAt
      __typename
    }
  }
`;
export const upsertUserProfile = /* GraphQL */ `
  mutation UpsertUserProfile($input: UpsertUserProfileInput!) {
    upsertUserProfile(input: $input) {
      id
      tenantKey
      userSub
      alertEmail
      phoneE164
      smsCriticalEnabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDevice = /* GraphQL */ `
  mutation CreateDevice(
    $input: CreateDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    createDevice(input: $input, condition: $condition) {
      id
      tenantKey
      propertyId
      buildingId
      unitId
      propertyCode
      buildingCode
      unitCode
      room
      assetType
      isActive
      hierKey
      label
      notes
      lastTelemetryAt
      lastTelemetryAtEpoch
      lastBattV
      lowBatteryActive
      activeLeak
      leakStartedAt
      leakClearedAt
      tiltActive
      tiltConsecutiveCount
      tiltStartedAt
      tiltClearedAt
      healthStatus
      healthHierKey
      healthAssetHierKey
      claimedAt
      firstOnlineAt
      lastSsid
      lastRssi
      connectionCount
      lastBootId
      lastUptime
      lastBootAt
      rebootCount
      firmware
      modelRev
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDevice = /* GraphQL */ `
  mutation UpdateDevice(
    $input: UpdateDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    updateDevice(input: $input, condition: $condition) {
      id
      tenantKey
      propertyId
      buildingId
      unitId
      propertyCode
      buildingCode
      unitCode
      room
      assetType
      isActive
      hierKey
      label
      notes
      lastTelemetryAt
      lastTelemetryAtEpoch
      lastBattV
      lowBatteryActive
      activeLeak
      leakStartedAt
      leakClearedAt
      tiltActive
      tiltConsecutiveCount
      tiltStartedAt
      tiltClearedAt
      healthStatus
      healthHierKey
      healthAssetHierKey
      claimedAt
      firstOnlineAt
      lastSsid
      lastRssi
      connectionCount
      lastBootId
      lastUptime
      lastBootAt
      rebootCount
      firmware
      modelRev
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDevice = /* GraphQL */ `
  mutation DeleteDevice(
    $input: DeleteDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    deleteDevice(input: $input, condition: $condition) {
      id
      tenantKey
      propertyId
      buildingId
      unitId
      propertyCode
      buildingCode
      unitCode
      room
      assetType
      isActive
      hierKey
      label
      notes
      lastTelemetryAt
      lastTelemetryAtEpoch
      lastBattV
      lowBatteryActive
      activeLeak
      leakStartedAt
      leakClearedAt
      tiltActive
      tiltConsecutiveCount
      tiltStartedAt
      tiltClearedAt
      healthStatus
      healthHierKey
      healthAssetHierKey
      claimedAt
      firstOnlineAt
      lastSsid
      lastRssi
      connectionCount
      lastBootId
      lastUptime
      lastBootAt
      rebootCount
      firmware
      modelRev
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProperty = /* GraphQL */ `
  mutation CreateProperty(
    $input: CreatePropertyInput!
    $condition: ModelPropertyConditionInput
  ) {
    createProperty(input: $input, condition: $condition) {
      id
      tenantKey
      code
      name
      address
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProperty = /* GraphQL */ `
  mutation UpdateProperty(
    $input: UpdatePropertyInput!
    $condition: ModelPropertyConditionInput
  ) {
    updateProperty(input: $input, condition: $condition) {
      id
      tenantKey
      code
      name
      address
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProperty = /* GraphQL */ `
  mutation DeleteProperty(
    $input: DeletePropertyInput!
    $condition: ModelPropertyConditionInput
  ) {
    deleteProperty(input: $input, condition: $condition) {
      id
      tenantKey
      code
      name
      address
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBuilding = /* GraphQL */ `
  mutation CreateBuilding(
    $input: CreateBuildingInput!
    $condition: ModelBuildingConditionInput
  ) {
    createBuilding(input: $input, condition: $condition) {
      id
      tenantKey
      propertyId
      code
      name
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBuilding = /* GraphQL */ `
  mutation UpdateBuilding(
    $input: UpdateBuildingInput!
    $condition: ModelBuildingConditionInput
  ) {
    updateBuilding(input: $input, condition: $condition) {
      id
      tenantKey
      propertyId
      code
      name
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBuilding = /* GraphQL */ `
  mutation DeleteBuilding(
    $input: DeleteBuildingInput!
    $condition: ModelBuildingConditionInput
  ) {
    deleteBuilding(input: $input, condition: $condition) {
      id
      tenantKey
      propertyId
      code
      name
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUnit = /* GraphQL */ `
  mutation CreateUnit(
    $input: CreateUnitInput!
    $condition: ModelUnitConditionInput
  ) {
    createUnit(input: $input, condition: $condition) {
      id
      tenantKey
      propertyId
      buildingId
      code
      name
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUnit = /* GraphQL */ `
  mutation UpdateUnit(
    $input: UpdateUnitInput!
    $condition: ModelUnitConditionInput
  ) {
    updateUnit(input: $input, condition: $condition) {
      id
      tenantKey
      propertyId
      buildingId
      code
      name
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUnit = /* GraphQL */ `
  mutation DeleteUnit(
    $input: DeleteUnitInput!
    $condition: ModelUnitConditionInput
  ) {
    deleteUnit(input: $input, condition: $condition) {
      id
      tenantKey
      propertyId
      buildingId
      code
      name
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createEvent = /* GraphQL */ `
  mutation CreateEvent(
    $input: CreateEventInput!
    $condition: ModelEventConditionInput
  ) {
    createEvent(input: $input, condition: $condition) {
      id
      tenantKey
      deviceId
      type
      ts
      message
      deviceLabel
      data
      __typename
    }
  }
`;
export const updateEvent = /* GraphQL */ `
  mutation UpdateEvent(
    $input: UpdateEventInput!
    $condition: ModelEventConditionInput
  ) {
    updateEvent(input: $input, condition: $condition) {
      id
      tenantKey
      deviceId
      type
      ts
      message
      deviceLabel
      data
      __typename
    }
  }
`;
export const deleteEvent = /* GraphQL */ `
  mutation DeleteEvent(
    $input: DeleteEventInput!
    $condition: ModelEventConditionInput
  ) {
    deleteEvent(input: $input, condition: $condition) {
      id
      tenantKey
      deviceId
      type
      ts
      message
      deviceLabel
      data
      __typename
    }
  }
`;
export const createInvite = /* GraphQL */ `
  mutation CreateInvite(
    $input: CreateInviteInput!
    $condition: ModelInviteConditionInput
  ) {
    createInvite(input: $input, condition: $condition) {
      id
      tenantKey
      code
      status
      emailLower
      expiresAt
      createdAt
      createdBySub
      acceptedAt
      acceptedBySub
      updatedAt
      __typename
    }
  }
`;
export const updateInvite = /* GraphQL */ `
  mutation UpdateInvite(
    $input: UpdateInviteInput!
    $condition: ModelInviteConditionInput
  ) {
    updateInvite(input: $input, condition: $condition) {
      id
      tenantKey
      code
      status
      emailLower
      expiresAt
      createdAt
      createdBySub
      acceptedAt
      acceptedBySub
      updatedAt
      __typename
    }
  }
`;
export const deleteInvite = /* GraphQL */ `
  mutation DeleteInvite(
    $input: DeleteInviteInput!
    $condition: ModelInviteConditionInput
  ) {
    deleteInvite(input: $input, condition: $condition) {
      id
      tenantKey
      code
      status
      emailLower
      expiresAt
      createdAt
      createdBySub
      acceptedAt
      acceptedBySub
      updatedAt
      __typename
    }
  }
`;
export const createTenant = /* GraphQL */ `
  mutation CreateTenant(
    $input: CreateTenantInput!
    $condition: ModelTenantConditionInput
  ) {
    createTenant(input: $input, condition: $condition) {
      id
      name
      ownerUserSub
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTenant = /* GraphQL */ `
  mutation UpdateTenant(
    $input: UpdateTenantInput!
    $condition: ModelTenantConditionInput
  ) {
    updateTenant(input: $input, condition: $condition) {
      id
      name
      ownerUserSub
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTenant = /* GraphQL */ `
  mutation DeleteTenant(
    $input: DeleteTenantInput!
    $condition: ModelTenantConditionInput
  ) {
    deleteTenant(input: $input, condition: $condition) {
      id
      name
      ownerUserSub
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserProfile = /* GraphQL */ `
  mutation CreateUserProfile(
    $input: CreateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    createUserProfile(input: $input, condition: $condition) {
      id
      tenantKey
      userSub
      alertEmail
      phoneE164
      smsCriticalEnabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserProfile = /* GraphQL */ `
  mutation UpdateUserProfile(
    $input: UpdateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    updateUserProfile(input: $input, condition: $condition) {
      id
      tenantKey
      userSub
      alertEmail
      phoneE164
      smsCriticalEnabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserProfile = /* GraphQL */ `
  mutation DeleteUserProfile(
    $input: DeleteUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    deleteUserProfile(input: $input, condition: $condition) {
      id
      tenantKey
      userSub
      alertEmail
      phoneE164
      smsCriticalEnabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createNotification = /* GraphQL */ `
  mutation CreateNotification(
    $input: CreateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    createNotification(input: $input, condition: $condition) {
      id
      tenantKey
      deviceId
      type
      severity
      openedAt
      lastNotifiedAt
      lastConfirmedAt
      title
      message
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNotification = /* GraphQL */ `
  mutation UpdateNotification(
    $input: UpdateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    updateNotification(input: $input, condition: $condition) {
      id
      tenantKey
      deviceId
      type
      severity
      openedAt
      lastNotifiedAt
      lastConfirmedAt
      title
      message
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNotification = /* GraphQL */ `
  mutation DeleteNotification(
    $input: DeleteNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    deleteNotification(input: $input, condition: $condition) {
      id
      tenantKey
      deviceId
      type
      severity
      openedAt
      lastNotifiedAt
      lastConfirmedAt
      title
      message
      createdAt
      updatedAt
      __typename
    }
  }
`;
